/// <reference path="../../lib/app.d.ts" />

import {WelcomeLayer} from "./welcome-layer";
import logging from "../utils/log";
import {StreamNotificationManager} from "./stream-notification";
export interface Toast
{
	message : string;
	params : ToastParams;
	timer ?: number;
	closing ?: boolean
}

export interface ToastParams
{
	timeout ?: number;
	instant ?: boolean;
	strong ?: boolean;
	keepAlive ?: boolean;
	onRemove ?: Function;
	onClick ?: Function;
	floattype ?: boolean;
}

/**
 * A ToastManager handles toast messages in the chat application.
 * A toast message is a simple message that shows up and hides after a specified timeout.
 */
export class ToastManager
{
	TAG = "[Sxc.Chat.ToastManager]";

	private toasts : Array<Toast> = [];
	private currentToast : Toast;

	private $toastNode;

	constructor(private $toastWrapper, private welcome : WelcomeLayer, private streamNotification : StreamNotificationManager)
	{
		this.$toastNode = $toastWrapper.find("[data-bind=toast-message]");

		this.$toastNode.on("click", () => {
			if (this.currentToast.params.onClick) {
				this.currentToast.params.onClick();
			}
		});
	}

	/**
	 * Adds a notification and forces the previous out of the screen
	 */
	push(msg : string, params : ToastParams)
	{
		let timeout = params.timeout || 5000;

		if (this.currentToast && this.currentToast.message === msg && params.keepAlive) {
			return;
		}

		params = {...params};
		params.timeout = params.timeout || 5000;

		let toast : Toast = {
			message: msg,
			params : params
		};

		if (params.instant) {

			// Purge all non-strong toasts
			for (let t of this.toasts) {
				// Simple purge, just shorten them
				if (!t.params.strong) t.params.timeout = 100;
			}

			logging.log(this.TAG, "toasts", [...this.toasts]);

			// Also remove the current if there is any

			if (this.currentToast
				&& !this.currentToast.params.strong
				&& !this.currentToast.closing)
			{
				clearTimeout(this.currentToast.timer);
				this.dismissCurrentToast();
			}
		}

		this.toasts.push(toast);
		if (!this.currentToast) this.showNext();
	}


	/**
	 * Shows next toast in the queue if it's possible (no other toasts are visible)
	 */
	private showNext()
	{
		logging.log(this.TAG, "[showNext]", [...this.toasts], {...this.currentToast});

		if (!this.toasts.length) return;

		this.currentToast = this.toasts.shift();

		this.$toastWrapper.addClass("sxc-visible").removeClass("float-type");
		if(this.currentToast.params.floattype){this.$toastWrapper.addClass("float-type");}

		this.welcome.fadeOut("toast");
		if (this.currentToast.params.onClick) {
			this.$toastWrapper.addClass("sxc-clickable");
		}

		this.streamNotification.fadeOut();

		this.$toastNode.html(this.currentToast.message);

		this.currentToast.timer = setTimeout(() => {
			this.dismissCurrentToast();
		}, this.currentToast.params.timeout);
	}

	dismissCurrentToast()
	{
		if (!this.currentToast) return;
		logging.log(this.TAG, "[dismissCurrentToast]", {...this.currentToast});
		this.currentToast.closing = true;
		clearTimeout(this.currentToast.timer);
		this.$toastWrapper.removeClass("sxc-visible");
		this.$toastWrapper.removeClass("sxc-clickable");

		setTimeout(() =>
		{
			logging.log(this.TAG, "[dismissCurrentToast2]", {...this.currentToast});

			this.$toastNode.empty();

			if (this.currentToast.params.onRemove) {
				this.currentToast.params.onRemove();
			}

			this.currentToast = null;

			this.welcome.fadeIn("toast");
			this.streamNotification.fadeIn();

			this.showNext();
		}, 300);
	}

	public setSize(size, rightMargin)
	{
		this.$toastWrapper.removeClass("sxcct-size-fs sxcct-size-normal");
		this.$toastWrapper.addClass("sxcct-size-" + size);
		this.$toastWrapper.css({
			right: rightMargin,
		});
	}
}
